import { KeyValue } from '@/main/models/common';
import { IInitialReducerData } from '@/main/services/reducerUtils';

export enum ParameterByTypeScreenTypes {
  GET_PARAMETER_BY_TYPE = '@parameterByTypeScreen/GET_PARAMETER_BY_TYPE',
  SAVE_PARAMETER_BY_TYPE = '@parameterByTypeScreen/SAVE_PARAMETER_BY_TYPE',
  RESET_REDUCER_PARAMETER_BY_TYPE = '@parameterByTypeScreen/RESET_REDUCER_PARAMETER_BY_TYPE'
}
export interface TypeParameterByTypeScreenState extends IInitialReducerData {}
export interface ParameterByTypeScreenState {
  readonly parameterByTypeScreen: {
    data: TypeParameterByTypeScreenState;
  };
  readonly isolated: { [key: string]: TypeParameterByTypeScreenState }; // check this
}

export interface GetParameterByTypeScreen {
  type: typeof ParameterByTypeScreenTypes.GET_PARAMETER_BY_TYPE;
  payload: {
    request: number;
    keyReducer: string;
  };
}

export interface SaveParameterByTypeScreen {
  type: typeof ParameterByTypeScreenTypes.SAVE_PARAMETER_BY_TYPE;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
    keyReducer: string;
  };
}

export interface ResetReducerParameterByTypeScreen {
  type: typeof ParameterByTypeScreenTypes.RESET_REDUCER_PARAMETER_BY_TYPE;
}

export type ParameterByTypeScreenActionTypes =
  | GetParameterByTypeScreen
  | SaveParameterByTypeScreen
  | ResetReducerParameterByTypeScreen;

